import React from "react";
import { NavLink } from "react-router-dom";
import { getCurrentUser } from "../auth";

export default function Navbar() {
  const user = getCurrentUser();
  const role = String(user?.role || "").toLowerCase();
  const roles = Array.isArray(user?.roles) ? user.roles.map(r => String(r).toLowerCase()) : [];
  const isAdmin = role === "admin" || role === "superadmin" || roles.includes("admin") || roles.includes("superadmin");
  const [open, setOpen] = React.useState(false);
  const menuRef = React.useRef(null);
  React.useEffect(() => {
    function onDocClick(e) {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);
  return (
    <nav style={{
      background: "#fffbe7",
      borderBottom: "1px solid #ffb300",
      padding: "10px 24px",
      fontWeight: 600,
      color: "#7B3F00",
      display: "flex",
      alignItems: "center",
      gap: "24px",
      justifyContent: "space-between"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
        <NavLink to="/" style={{ color: "#7B3F00", textDecoration: "none" }}>Home</NavLink>
        <span style={{ opacity: 0.7 }}>Switch System</span>
        <NavLink to="/sis/dashboard" style={{ color: "#7B3F00", textDecoration: "none" }}>SIS</NavLink>
        <NavLink to="/finance/dashboard" style={{ color: "#7B3F00", textDecoration: "none" }}>Finance</NavLink>
        <NavLink to="/hr/payroll" style={{ color: "#7B3F00", textDecoration: "none" }}>HR / Payroll</NavLink>
        <NavLink to="/uniforms/inventory" style={{ color: "#7B3F00", textDecoration: "none" }}>Uniforms</NavLink>
        <NavLink to="/books/inventory" style={{ color: "#7B3F00", textDecoration: "none" }}>Books</NavLink>
        <NavLink to="/teacher/dashboard" style={{ color: "#7B3F00", textDecoration: "none" }}>Teacher Portal</NavLink>
        <NavLink to="/admin/dashboard" style={{ color: "#7B3F00", textDecoration: "none" }}>Admin</NavLink>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
        <NavLink to="/finance/dashboard" style={{ color: "#7B3F00", textDecoration: "none" }}>Dashboard</NavLink>
        <NavLink to="/finance/transactions" style={{ color: "#7B3F00", textDecoration: "none" }}>Collections & Transactions</NavLink>
        <NavLink to="/finance/financial-reports" style={{ color: "#7B3F00", textDecoration: "none" }}>Financial Reports</NavLink>
        {isAdmin && (
          <div ref={menuRef} style={{ position: "relative" }}>
            <button
              className="btn btn-sm btn-outline-warning"
              onClick={() => setOpen(o => !o)}
              aria-haspopup="true"
              aria-expanded={open ? "true" : "false"}
            >
              Admin Tasks ▾
            </button>
            {open && (
              <div
                role="menu"
                style={{
                  position: "absolute",
                  right: 0,
                  top: "100%",
                  background: "#fffef4",
                  border: "1px solid #ffcc66",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  borderRadius: 8,
                  minWidth: 240,
                  padding: 8,
                  zIndex: 1000
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <NavLink to="/admin/migrate" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Data Migration</NavLink>
                  <NavLink to="/admin/cleanup" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Data Cleanup</NavLink>
                  <NavLink to="/admin/sections" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Grade Sections</NavLink>
                  <NavLink to="/admin/reassign-sections" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Reassign Sections</NavLink>
                  <NavLink to="/sis/school-year" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>School Year</NavLink>
                  <NavLink to="/admin/announcements" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Announcements</NavLink>
                  <NavLink to="/admin/claims-manager" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Claims Manager</NavLink>
                  <NavLink to="/sis/attendance" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Attendance</NavLink>
                  <div style={{ borderTop: "1px solid #ffe082", margin: "6px 0" }} />
                  <NavLink to="/finance/settings/chart-of-accounts" onClick={() => setOpen(false)} style={{ padding: "8px 10px", color: "#7B3F00", textDecoration: "none", borderRadius: 6 }}>Chart of Accounts</NavLink>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
